/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finish_Before_StartInputs */



/**
* | output |
* | --- |
* | "Finish time cannot be earlier than start time" |
*
* @param {Err_Tournament_Finish_Before_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finish_before_start = /** @type {((inputs?: Err_Tournament_Finish_Before_StartInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finish_Before_StartInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'heure de fin ne peut pas être antérieure à l'heure de début")
	if (locale === "es") return /** @type {LocalizedString} */ ("La hora de finalización no puede ser anterior a la hora de inicio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A hora de término não pode ser anterior à hora de início")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'orario di fine non può precedere l'orario di inizio")
	return /** @type {LocalizedString} */ ("Finish time cannot be earlier than start time")
});